import React, { useEffect } from 'react';

import { ZeosSpinner } from './ZeosSpinner';

interface IZeosModalSpinnerProps {
  isVisible: boolean;
  message?: string;
}

export const ZeosModalSpinner = ({
  isVisible,
  message = "Loading...",
}: IZeosModalSpinnerProps) => {
  useEffect(() => {
    // Prevent body scroll when modal is visible
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-xl p-8 flex flex-col items-center justify-center min-w-64">
        <ZeosSpinner />
        {message && (
          <p className="mt-4 text-gray-600 text-center font-medium">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};
